
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SupplierAnswer.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierAnswer.ts

import {Question } from "./Question";
export class SupplierAnswer {

  // int Id
  public Id: number=0;

  // int SupplierId
  public SupplierId: number=0;

  // int QuestionId
  public QuestionId: number=0;

  // byte? Answer
  public Answer?: number=null;

  // Question Question
  public Question: Question=null;
}